import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { ProductCollectionModel } from "@insite/client-framework/Types/ApiModels";

interface MyProductsApiParameters extends ApiParameter {
    sort: string;
    includeSuggestions: boolean;
    expand: string[];
    applyPersonalization: boolean;
    includeAttributes: string[];
    page: number;
    pageSize: number;
}

export function getMyProducts(params: MyProductsApiParameters) {
    const apiUrl = `/api/v2/MyProducts`;
    return get<ProductCollectionModel>(`${apiUrl}`, params);
}
